import uuid from 'uuid/v4';
import { JL } from 'jsnlog';

let store;

export function setLoggerReduxStore(reduxStore) {
  store = reduxStore;
}

export const sessionId = uuid();

const beforeSendSetRequestId = (xhr, json) => {
  xhr.setRequestHeader('X-RequestId', sessionId);
  xhr.setRequestHeader('X-Client', 'accountPortal');
  xhr.withCredentials = true;
  if(store) {
    const currentState =  store.getState();
    if(currentState.oidc && currentState.oidc.user && !currentState.oidc.user.expired) {
      const access_token = currentState.oidc.user.access_token;
      xhr.setRequestHeader('Authorization', 'Bearer ' + access_token);
    }
  }
}

const appenders = [];

const serverUrl = `${process.env.REACT_APP_CL_ENDPOINT}/api/log/jl`;


const serverAppender = JL.createAjaxAppender('cl');
serverAppender.setOptions({
  url: serverUrl,
  beforeSend: beforeSendSetRequestId,
  bufferSize: 20,
  sendWithBufferLevel: "ERROR",
  batchSize: 50,
  maxBatchSize: 200,
  batchTimeout: 10000
});

appenders.push(serverAppender);

if(process.env.REACT_APP_MODE === 'development') {
  const consoleAppender = JL.createConsoleAppender('clconsole');
  consoleAppender.setOptions({

  });
  appenders.push(consoleAppender);
}

JL().setOptions({
  appenders: appenders
});



export const logger = JL;
